export const blockIconsTransportationHailNew = (
	<span className='material-symbols-outlined'>hail</span>
);
